<script>
export default {
  name: "ErrorMailing",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  computed: {
    errors() {
      return this.params.errors;
    },
    count() {
      return this.params.count;
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-md">
    <header class="p-2 text-center">
      <span>{{ $t("views.modals.error", { count }) }}</span>
    </header>
    <div class="p-4 border-t-2 border-solid border-gray-300">
      <div v-for="err in errors" :key="err">
        <span>{{ err }}</span>
      </div>
    </div>
  </div>
</template>
